module.exports = __webpack_public_path__ + "static/media/menu_burger.5f0885e0.svg";